import { NotFoundError } from "./not-found-error";

// Thrown when a scanned code names no load carrier unit the caller's organisation owns.
//
// The lookup is org-scoped by the `loadCarrierUnits` policy, so a label from another
// organisation's yard is indistinguishable from a label that never existed — and that is the
// right answer to give: the scanner learns the box is not theirs to move, and learns nothing
// about whose it is. 404: there is no row to have a conflict with. The caller is wearing gloves
// and looking at a screen from a metre away, which is why the refusal has a key of its own.
export class UnknownShippingLabelError extends NotFoundError {
	constructor() {
		super("stock.unknown_shipping_label");
		this.name = "UnknownShippingLabelError";
	}
}
